module.exports = __webpack_public_path__ + "34bc775d/img/chevron-down-icon.5542f65c.svg";